<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-lg-6 col-md-10 col-sm-12">
                <div class="row my-4">
                  <h5 class="card-title col-lg-12">Select a Safety Form</h5>
                </div>
                <div>
                  <div
                    class="col-lg-12 card safety-form-card"
                    v-b-modal.modal-safetyForm
                    v-for="form in safetyForms"
                    :key="form.docId"
                    @click="selectedForm = form"
                  >
                    <div class="card-body safety-form-card-body row">
                      <div class="col-lg-11">
                        <h5 class="mt-0 mb-4">{{ form.displayName }}</h5>
                        <p class="card-text">{{ form.description }}</p>
                      </div>
                      <div class="col-lg-1 d-flex align-items-center">
                        <i class="bx bx-right-arrow-alt h1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Safety Form Modal -->
    <b-modal
      id="modal-safetyForm"
      class="safety-form-modal"
      scrollable
      centered
      ok-title="Submit"
      @show="handleSafetyFormModalShow"
      @hidden="handleSafetyFormModalHide"
      @ok="handleSafetyFormModalSubmit"
    >
      <div slot="modal-header">
        <h4>{{ selectedForm.displayName }}</h4>
        <p>{{ selectedForm.description }}</p>
      </div>
      <div v-for="input in selectedForm.inputs" :key="input.edit">
        <div style="text-align: end">
          <div
            class="row mb-3"
            v-if="
              input.type === 'checkbox' ||
                input.type === 'textarea' ||
                input.type === 'number'
            "
          >
            <label class="col-6 my-auto">
              <span
                v-if="input.required && input.type !== 'checkbox'"
                style="color: #f46a6a"
                >*</span
              >
              {{ input.label }}
            </label>
            <b-checkbox
              v-if="input.type === 'checkbox'"
              :id="input.name.replace(/\s+/g, '')"
              v-model="input.value"
              :type="input.type"
            />
            <b-textarea
              class="col-5"
              :id="input.name.replace(/\s+/g, '')"
              v-else-if="input.type === 'textarea'"
              :type="input.type"
              v-model="input.value"
            />
            <b-form-input
              class="col-2"
              :id="input.name.replace(/\s+/g, '')"
              v-else-if="input.type === 'number'"
              :type="input.type"
              v-model="input.value"
            />
          </div>
          <div class="row mb-3 text-center" v-else-if="input.type === 'label'">
            <h5 class="col-12">{{ input.label }}</h5>
          </div>
          <div class="row mb-4" v-else-if="input.type === 'dropdown'">
            <label class="col-6 my-auto">
              <span
                v-if="input.required && input.type !== 'checkbox'"
                style="color: #f46a6a"
                >*</span
              >
              {{ input.label }}
            </label>
            <b-form-select
              v-if="input.collectionData !== undefined"
              class="col-5"
              :id="input.name.replace(/\s+/g, '')"
              :options="input.collectionData.values"
              v-model="input.value"
              full-width
            ></b-form-select>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Safety Form Modal End -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import routes from '../../../routes.js';
import firebase from 'firebase';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { cssEscape } from '../helper/helpers';

Vue.use(VueToast);

export default {
  page: {
    title: 'submitSafetyForm',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: 'Submit Safety Forms',
      name: 'submitSafetyForm',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'submit safety forms',
          href: '/production/safety/submitSafetyForm',
          active: true,
        },
      ],
      routes: routes,
      safetyForms: [],
      selectedForm: { values: [] },
    };
  },
  methods: {
    handleSafetyFormModalShow: function() {
      // if the form contains a dropdown input then retrieve it's associated collection and add it to the specific input object
      this.selectedForm.inputs.map((input) => {
        if (input.type === 'dropdown') {
          // query for collection data
          firebase
            .firestore()
            .collection('customCollections')
            .where('name', '==', input.collection)
            .where('org', '==', sessionStorage.getItem('org'))
            .get()
            .then((snapshot) => {
              snapshot.docs.map((doc) => {
                let modifiedDocData = doc.data();
                modifiedDocData['docId'] = doc.id;

                // find index of this specific input
                let index = this.selectedForm.inputs.findIndex(
                  (x) => x.edit === input.edit
                );
                this.$set(
                  this.selectedForm.inputs[index],
                  'collectionData',
                  modifiedDocData
                );
              });
            });
        }
      });
    },
    handleSafetyFormModalHide: function() {
      // reset modal values
      this.selectedForm.inputs.map((input) => {
        input.value = null;
      });
    },
    handleSafetyFormModalSubmit: function(bvModalEvt) {
      let safetyForm = {};
      let valid = true;

      // validate form inputs
      this.selectedForm.inputs.map((input) => {
        // remove spaces from name
        let name = input.name.replace(/\s+/g, '');
        let element = document.querySelector(`#${cssEscape(name)}`);

        if (
          (input.value === undefined ||
            input.value === null ||
            (input.type !== 'checkbox' ? input.value.trim() === '' : '')) &&
          input.required &&
          input.type !== 'label' &&
          input.type !== 'checkbox'
        ) {
          // add error class to specific input component
          if (element !== null) {
            element.classList.add('is-invalid');
          }
          valid = false;
        } else {
          // remove error class / add the name/value pair to form object / add null if no value exists
          if (input.type !== 'label') {
            if (element !== null) {
              element.classList.remove('is-invalid', 'ddl-is-invalid');
            }
            if (input.value === undefined || input.value === null) {
              if (input.type === 'checkbox') {
                // if a checkbox is left untouched when submitted then we need to set its value to false instead of null
                safetyForm[name.toLowerCase()] = false;
              } else {
                safetyForm[name.toLowerCase()] = null;
              }
            } else {
              safetyForm[name.toLowerCase()] = input.value;
            }
          }
        }
      });

      if (valid) {
        safetyForm['associatedFormID'] = this.selectedForm.docId;
        safetyForm['dateSubmitted'] = new Date();
        safetyForm['org'] = sessionStorage.getItem('org');
        safetyForm['employee'] = JSON.parse(
          sessionStorage.getItem('authUser')
        ).displayName;
        safetyForm['user'] = firebase.auth().currentUser.uid;
        // write a new safety form to db
        try {
          firebase
            .firestore()
            .collection('safetyForms')
            .add(safetyForm)
            .then(() => {
              Vue.$toast.open({
                message: 'Successfully submitted safety form',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });    
            })
            .catch((err) => {
              Vue.$toast.open({
                message: `Error submitting safety form to database`,
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
              console.log('Error submitting safety form to database: ', err);
            });
        } catch (err) {
          Vue.$toast.open({
            message: `Error submitting safety form`,
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
          console.log('Error submitting safety form: ', err);
        }
      } else {
        bvModalEvt.preventDefault();
      }
    },
    getOrgSafetyForms: function() {
      // get all safety forms to display for the current user's organization
      try {
        firebase
          .firestore()
          .collection('organizations')
          .doc(sessionStorage.getItem('org'))
          .collection('safetyForms')
          .orderBy('displayName', 'asc')
          .get()
          .then((snapshot) => {
            let safetyFormDocs = [];
            snapshot.docs.map((doc) => {
              if(!doc.data().dateDeactivated) {
                let modifiedDocData = doc.data();
                modifiedDocData['docId'] = doc.id;
                safetyFormDocs.push(modifiedDocData);
              }
            });
            this.safetyForms = safetyFormDocs;
          });
      } catch (err) {
        Vue.$toast.open({
          message: `Error retrieving safety forms for your organization`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
        console.log(err);
      }
    },
  },
  created: function() {
    this.getOrgSafetyForms();
  },
};
</script>

<style lang="scss" scoped>
.safety-form-card {
  border: 1px solid #eff2f7;
  .required-label-symbol {
    color: #f46a6a;
  }
}
.safety-form-card:hover {
  cursor: pointer;
  transition: 0.2s ease-in;
  border-color: #556ee6;
  h5,
  p,
  i {
    color: #556ee6;
  }
}
</style>
